import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NETWORK_ERROR, NETWORK_ERROR_FOR_DISPLAY, NETWORK_ERROR_GEO } from 'consts';

import styles from './ErrorCodeInfo.module.scss';

function ErrorCodeInfo({ code, autoRetryTimer }: { code: string | number; autoRetryTimer: number | undefined }) {
  if (code === NETWORK_ERROR_GEO || autoRetryTimer !== undefined) {
    return null;
  }

  const isNetworkError = typeof code === 'string' && code === NETWORK_ERROR;

  return (
    <span className={styles.code}>
      {isNetworkError ? (
        <FormattedMessage
          defaultMessage={`Error Code: ${NETWORK_ERROR_FOR_DISPLAY}`}
          id='ApiError.errorCode.networkError'
        />
      ) : (
        <FormattedMessage defaultMessage='Error Code: {code}' id='ApiError.errorCode' values={{ code }} />
      )}
    </span>
  );
}

export default ErrorCodeInfo;
